<template>
  <div class="h-100">
    <div v-bar>
      <div class="d-flex flex-column">
        <div class="d-flex justify-content-center">
          <div class="brand mt-5 mb-5">
            <img src="/images/logo.png" width="225" />
          </div>
        </div>
        <b-row>
          <b-col
            :class="{ out: welcome }"
            class="login-wrapper m-auto"
            lg="5"
            md="7"
            sm="10"
          >
            <div class="login-user">
              <b-avatar
                :src="`/storage/avatars/${user.avatar}_md.jpg`"
                :text="
                  $options.filters.initials(
                    `${user.firstname} ${user.lastname}`,
                  )
                "
                class="shadow-lg"
                size="175px"
                variant="light"
              />
              <h1>
                Vitajte,
                <span class="font-weight-normal"
                  >{{ user.firstname }} {{ user.lastname }}</span
                >
              </h1>
            </div>
            <b-card no-body class="login-card shadow-lg mb-5">
              <b-card-body v-if="downtime && Object.keys(downtime).length">
                <b-alert class="mb-0 font-weight-bold" variant="warning" show>
                  Plánovaná údržba systému {{ downtime.description }} od
                  {{ downtime.from | formatDateTime }} do
                  {{ downtime.to | formatDateTime }}
                </b-alert>
              </b-card-body>
              <b-card-body
                v-if="
                  authStatus.message && (attempts || authStatus.code === 440)
                "
              >
                <b-alert class="mb-0" variant="danger" show>
                  {{ authStatus.message }}
                </b-alert>
              </b-card-body>
              <b-card-body class="mr-5">
                <b-form-row>
                  <b-col offset-md="3">
                    <h2 class="card-title">Prihlásenie</h2>
                  </b-col>
                </b-form-row>
                <b-form @submit.prevent="login">
                  <!-- Email -->
                  <b-form-group
                    label="Email"
                    label-align-md="right"
                    label-cols-md="3"
                    label-for="email"
                  >
                    <b-input-group
                      :class="{ 'is-invalid': errors.has('email') }"
                      class="input-group-labeled"
                    >
                      <b-input-group-prepend is-text>
                        <b-icon icon="person-check" />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="form.email"
                        v-validate="'required|email'"
                        :class="{ 'is-invalid': errors.has('email') }"
                        class="pl-0"
                        data-vv-as="Email"
                        name="email"
                      />
                    </b-input-group>
                    <b-form-invalid-feedback>
                      {{ errors.first('email') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <!-- Password -->
                  <b-form-group
                    label="Heslo"
                    label-align-md="right"
                    label-cols-md="3"
                    label-for="email"
                  >
                    <b-input-group
                      :class="{ 'is-invalid': errors.has('password') }"
                      class="input-group-labeled"
                    >
                      <b-input-group-prepend is-text>
                        <b-icon icon="key" />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="form.password"
                        v-validate="'required'"
                        :class="{ 'is-invalid': errors.has('password') }"
                        :type="!showPass ? 'password' : 'text'"
                        class="pl-0 border-right-0"
                        data-vv-as="Heslo"
                        name="password"
                      />
                      <b-input-group-append>
                        <b-btn variant="link" @click="showHide">
                          <b-icon :icon="showPass ? 'eye' : 'eye-slash'" />
                        </b-btn>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback>
                      {{ errors.first('password') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <!-- Remember Me -->
                  <b-form-group label-cols-md="3" label-for="remember">
                    <b-form-checkbox v-model="remember" name="remember">
                      Zapamätať si
                    </b-form-checkbox>
                    <!--<router-link :to="{ name: 'password.request' }" class="small ml-auto my-auto">Zabudnuté heslo</router-link>-->
                  </b-form-group>
                  <b-form-group label-cols-md="3" label-for="login">
                    <b-btn
                      class="text-uppercase"
                      type="submit"
                      variant="primary"
                      @click.prevent="login"
                    >
                      <b-icon class="mr-1" icon="unlock" />
                      Prihlásiť sa
                    </b-btn>
                  </b-form-group>
                </b-form>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-container class="login-footer mt-auto" :class="{ out: welcome }">
          <div class="my-3">
            <b-row class="align-items-center">
              <b-col>
                <p class="text-center">
                  <b>ESM Consulting, s. r. o.</b><br />
                  Jarková 14, Prešov 080 01<br />
                </p>
              </b-col>
              <b-col>
                <p class="text-center">
                  <span class="text-muted">IČO:</span> 52 722 490<br />
                  <span class="text-muted">DIČ:</span> 2121130154<br />
                  <span class="text-muted">IBAN:</span> SK89 8330 0000 0021 0206
                  1241
                </p>
              </b-col>
              <b-col>
                <p class="text-center">
                  <b-icon class="mr-1" icon="house-door" />
                  Jarková 14, Prešov 080 01<br />
                  <b-icon class="mr-1" icon="telephone" />
                  +421907 788 536<br />
                  <b-icon class="mr-1" icon="telephone" />
                  +421905 340 972<br />
                  <b-icon class="mr-1" icon="envelope" />
                  dodavatel@e-sm.eu<br />
                </p>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import store from '../../store'
import axios from 'axios'

export default {
  data: function () {
    return {
      form: {
        email: null,
        password: null,
      },
      showPass: false,
      remember: false,
      welcome: false,
      attempts: null,
      downtime: {},
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user.current,
      authStatus: (state) => state.user.authStatus,
    }),
  },
  created() {
    axios.get('downtimes/get_current').then((res) => {
      this.downtime = res.data.data
    })
  },
  methods: {
    login() {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.attempts++
          this.$store
            .dispatch('user/login', {
              username: this.form.email,
              password: this.form.password,
            })
            .then(() => {
              this.welcome = true
              let redirect = this.$auth.redirect()
              setTimeout(() => {
                //redirect ? this.$router.back() : this.$router.push('/')
                this.$router.push('/')
                if (this.$root.userData.energetics_count === 0) {
                  this.$swal({
                    type: 'error',
                    position: 'top',
                    showCloseButton: true,
                    text: 'Nemáte žiadne oprávnenia',
                  })
                }
              }, 4000)
              store.dispatch('user/setAuthStatus', {})
            })
            .catch((err) => {
              if (err.response.data.message) {
                this.$store.dispatch('user/setAuthStatus', {
                  code: err.response.status,
                  message: err.response.data.message,
                })
              }
            })
        }
      })
    },
    showHide() {
      this.showPass = !this.showPass
    },
  },
}
</script>
